<template >
    <h class="mb-1 text-base font-medium text-racing-stars-yellow text-center text-2xl">All Done!</h>

    <p class="text-center text-base  max-w-sm">Looks like your ready to go!</p>
    <p class="text-center text-base  max-w-sm">If you ever need any help or have any questions feel free to consult our <a href="https://racingstars.co.uk/how" class = "">how to play</a> page or get in touch via support or <a href="https://twitter.com/racingstarsltd?lang=en">social media.</a></p>


    <button type="button" :v-model="tutorialStep" @click.stop="updateTutorialStep(tutorialStep+1)"
        class="mt-2 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-black bg-racing-stars-yellow hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
        Next step
    </button>
</template>

<script>
import Popper from 'vue3-popper'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronUpIcon, ChevronDownIcon} from '@heroicons/vue/outline'

export default {
    props: {
        meeting: {
            type: Object,
            default: {}
        },
        tutorialStep: {
            type : Number,
        },
        selections: {
            type : Object,
        },
    },

    emits: ['updateTutorialStep'],

    setup(props, {emit}){
        const updateTutorialStep = (tutorialStep) => {
            emit('updateTutorialStep', tutorialStep)
        }

        const getExp = () => {
            axios.get(route('api.tutorial.get'))
                .then(response => {
                    level.value = response.data
                })
        }

        return {
            getExp,
            updateTutorialStep,
        }
    },

    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Popper,
        ChevronDownIcon,
        ChevronUpIcon,
    },
}

</script>